// Todas las arquitecturas de la guia (las de ejemplo y las profesionales) con sus controles de seguridad y su revision por pilares.
import BASE from "../arquitecturas";
import PRO from "./arquitecturasPro";
import SEG from "./controles";

export const PILARES = [["seg", "Seguridad", "fa fa-lock", "#d13212"], ["fia", "Confiabilidad", "fa fa-heartbeat", "#1d8102"], ["ren", "Rendimiento", "fa fa-tachometer-alt", "#0972d3"],
    ["cos", "Costos", "fa fa-coins", "#b7791f"], ["ope", "Excelencia operativa", "fa fa-cogs", "#6b4fbb"], ["sos", "Sostenibilidad", "fa fa-leaf", "#2e7d32"]];

const ORDEN = ["Aplicaciones", "Datos", "Desarrollo", "Redes", "Gobierno y seguridad", "Recuperación ante desastres"];
const TODAS = [...BASE, ...PRO].map(a => ({ categoria: "Aplicaciones", ...a, controles: (SEG[a.id] || {}).controles || [], pilares: (SEG[a.id] || {}).pilares || null }));
export default TODAS.map((a, k) => [a, k]).sort((x, y) => ORDEN.indexOf(x[0].categoria) - ORDEN.indexOf(y[0].categoria) || x[1] - y[1]).map(x => x[0]);
